/**
 * Hero carousel — 6 slides.
 * Replace `src` with your own files: `${process.env.PUBLIC_URL}/carousel/1.jpg` … `6.jpg`
 * (put images in `public/carousel/`).
 */
export const HERO_CAROUSEL_SLIDES = [
  {
    src: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=1600&q=80&auto=format&fit=crop',
    alt: 'Laptops and mobile computing',
    kicker: 'Welcome',
    title: 'Gear up with quality tech',
    subtitle: 'Browse featured items and filter by category — same store, clearer layout on every device.'
  },
  {
    src: '/computer-parts-banner.png',
    alt: 'Computer parts banner',
    kicker: 'Computer parts',
    title: 'Computer parts',
    subtitle: 'Top components and brands for your PC build.'
  },
  {
    src: '/networking-banner.png',
    alt: 'Networking parts banner',
    kicker: 'Networking',
    title: 'Networking parts',
    subtitle: 'Routers, switches, access points, and rack solutions for home and business networks.'
  },
  {
    src: '/cctv-banner.png',
    alt: 'CCTV solutions banner',
    kicker: 'CCTV',
    title: 'CCTV solutions',
    subtitle: 'Top brands for your security setup - cameras, recorders, and complete surveillance bundles.'
  },
  {
    src: '/solar-banner.png',
    alt: 'Solar products banner',
    kicker: 'Solar products',
    title: 'Solar products',
    subtitle: 'Inverters, panels, and LiFePO4 batteries for efficient and reliable solar power systems.'
  },
  {
    src: '/fiber-banner.png',
    alt: 'Fiber products banner',
    kicker: 'Fiber products',
    title: 'Fiber products',
    subtitle: 'Fiber cables, OLT/ONU gear, and installation essentials for reliable internet connectivity.'
  }
];
